export default () => `
  <div class="content">
    Minimum setback distance from roof edges. Additional setback may be required based on code requirements.
  </div>
`;
